// @flow
'use strict';

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { openSelector, fechaModal, totalDocumentosSelector, exportaLote } from '../../../../../reducers/modal_exportacao_lote';

import ModalExportacaoLote from '../../../../common/modal_exportacao_lote';

const mapStateToProps = createStructuredSelector({
  open: openSelector, totalDocumentos: totalDocumentosSelector,
});

export default connect<*, *, *, *, *, *>(mapStateToProps, { fechaModal, exportaLote })(ModalExportacaoLote);
